import { useCallback, useEffect, useState } from "react";
import { OdcService } from "../services/OdcService";

export const useHookOdc = () => {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [params, setParams] = useState({
    pop_id: null,
    nas_id: null,
    olt_id: null,
    central_odc_id: null,
    keyword: null,
    order_by: null,
    sort: null,
    page: 1,
  });

  const getData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await OdcService.get({ params:params});
      setData(res.data.data);  
      setMeta(res.data.meta);  
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    getData();
  }, [getData]);

  return {
    data,
    meta,
    loading,
    error,

    params,
    setParams,
    refreshData: () => getData(),
  };
};
